import * as actionTypes from './ActionTypes';

const axiosPayLoad = {
  generalSystemParameter: [],
  logCheckTabObj: {},
  logCheckList: [],
  saveOrUpdateMessage: '',
  validationError: {},
  saveAfterList: [],
};

const reducer = (state = axiosPayLoad, action) => {
  switch (action.type) {
    case actionTypes.GET_GENERAL_SYSTEM_PARAMETER:
      return {
        ...state,
        generalSystemParameter: action.generalSystemParameter,
      };
    case actionTypes.ADD_NEW_LOG_CHECK:
      return { ...state, logCheckList: action.logCheckList };
    case actionTypes.SAVE_OR_UPDATE:
      return { ...state, saveOrUpdateMessage: action.saveOrUpdateMessage };
    case actionTypes.LOG_CHECK_TAB_DATA:
      return { ...state, logCheckTabObj: action.logCheckTabObj };
    case actionTypes.SAVE_AFTER_LIST_DATA:
      return { ...state, saveAfterList: action.saveAfterList };
    default:
      return state;
  }
};

export default reducer;
